<template>
  <div class="search_status_content">
    <img
      src="../assets/img/moppy.gif"
      alt=""
      v-show="collections.map((v) => v.loading).includes(true)"
    />
    <img
    style="height:23px"
      src="../assets/img/moppy1.png"
      alt=""
      v-show="!collections.map((v) => v.loading).includes(true)"
      @click="showWords()"
      class="toggleWordsList"
    />

    <span class="wordContent" v-if="flag == 'word' && showTxt"
      :class="{ 'ng-word-color': txt_type == 'ng',
      'wow-word-color': txt_type == 'wow',
      'warning-word-color': txt_type == 'warning'}">
      {{txt}}
    </span>
    <span
      v-else
      :title="$store.state.sysInit.navigationText"
      :class="{ 'ng-word-color': txt_type == 'ng','wow-word-color': txt_type == 'wow', 'warning-word-color': txt_type == 'warning'  }"
    >
      {{ txt }}
    </span>

    <div v-if="$store.state.stt.navigationTxtShow" class="list_container">
      <div v-for="(item,idx) in $store.state.stt.wordList" :key="idx">
        <div :class="{ 'ng-word-color': item['type'] == 'ng',
        'wow-word-color': item['type'] == 'wow', 'warning-word-color': item['type'] == 'warning' }"
        >{{item['origin']}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data(){
    return {
      showWordListFlag: false,
      showTxt: false,
      txt: '',
      txt_type : '',
      flag : ''
    }
  },
  computed: {
    ...mapGetters("discovery", {
      collections: "getCollections",
    }),
    ...mapGetters("stt", {
      sttNotes: "getSttNotes",
    }),
  },
  watch: {
    "$store.state.sysInit.navigationText": function() {
      if(this.$store.state.sysInit.navigationText){
        if(this.$store.state.sysInit.navigationText.indexOf('ng/wow:') > -1){
          this.flag = 'word';
          this.renderTxt();
        }else if(this.$store.state.sysInit.navigationText.indexOf('ng/clear:') > -1){
          this.flag = 'word';
          this.txt = '';
          this.txt_type = '';
        }else{
          this.flag = 'other';
          this.txt = this.$store.state.sysInit.navigationText;
          this.txt_type = '';
        }
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.hideWords);
  },
  methods:{
    showWords(){
      if(this.$store.state.stt.wordList.length > 0){
        this.$store.state.stt.navigationTxtShow = !this.$store.state.stt.navigationTxtShow;
      }
    },
    hideWords(e){
      if(e.target.className != 'toggleWordsList' 
        && e.target.className != 'ng-word-color' && e.target.className != 'wow-word-color'  && e.target.className != 'warning-word-color'){
        if(this.$store.state.stt.navigationTxtShow){
          this.$store.state.stt.navigationTxtShow = false;
        }
      }    
    },
    async renderTxt(){   
      for(let i = 0; i < this.$store.state.stt.wordList.length; i++){
        let word = this.$store.state.stt.wordList[i];
        if(word['status'] == '0'){
          await this.sleep(1000); 
          this.showTxt = true;
          this.txt = word['content'];
          this.txt_type = word['type'];
          this.$store.state.stt.wordList[i]['status'] = '1';
          await this.sleep(2000);
          this.showTxt = false;
          // this.txt = '';
        }
      }
    } ,
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>
<style lang="scss" scoped>
.search_status_content{
  height: 32px;
  padding: 4px;

  span {
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
    width: calc(100% - 34px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 26px;
    vertical-align: middle;
  }

  img {
    height: 100%;
  }
}

.list_container{
  position: absolute;
  bottom: 76px;
  left: 10px;
  right: 10px;
  padding: 10px 5px;
  padding: 10px;
  line-height: 20px;
  font-size: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  max-height: 280px;
  overflow-y: auto;
  background-color: white;
}

@keyframes slideUp {
  0%,
  50% {
    transform: translateY(100%);
    opacity: 0;
  }
    
  60%,
  100% {
    transform: translateY(0);
    opacity: 1;
  
  }
}

.wordContent {
  animation-name: slideUp;
  animation-duration: 1s;
  animation-timing-function: ease-in;
  display: block;
}

.wordContent > span {
  text-align: left;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}
</style>